import Cookies from "js-cookie";
const userInfo = "lxcf-userInfo";
const RAINDROP_TOKEN_KEY = "lxcf-raindrop-token";
const expires = new Date(Date.now() + 1000 * 60 * 60 * 23);

export function setToken(token: string) {
  // 设置 raindrop-token
  Cookies.set(RAINDROP_TOKEN_KEY, token, { expires: expires });
}

export function getToken() {
  if(process.env.NODE_ENV === 'development') {
    return '092956fd84c94b999db1dcd26575928d';
  }
  return Cookies.get(RAINDROP_TOKEN_KEY);
}

export function getAuthorization() {
  return Cookies.get(RAINDROP_TOKEN_KEY);
}

export function removeToken() {
  Cookies.remove(RAINDROP_TOKEN_KEY);
}
export function setUserInfo(encryptInfo) {
  remove(userInfo)
  return Cookies.set(userInfo, encryptInfo, { expires: expires });
}

export function getUserInfo() {
  return Cookies.get(userInfo)
}

export function remove(KeyName) {
  return Cookies.remove(KeyName);
}
